import Header from '@/components/elements/Header/Header';
import { ListItem, ListItemContent } from '@/components/elements/lists';
import Icon from '@/components/icons/Icon';
import { _s } from '@/locale';
import { CampaignProduct, PlaceEmployee, PlaceService } from '@/types/state/shared';
import { Fragment } from 'react/jsx-runtime';
import EmployeeItem from './EmployeeItem';
import PickedProduct from './PickedProduct';
import PickedService from './PickedService';

const baseTranslationKey = 'components.modules.modals.BookAppointment.shared.Summary';

export type SummaryProps = {
  pickedEmployee: PlaceEmployee;
  pickedServices: PlaceService[];
  pickedProducts: CampaignProduct[];
  showAddAdditionalService?: boolean;
  showPickedEmployee?: boolean;
  showPickedServices?: boolean;
  showPickedProducts?: boolean;
  onRemoveService?: (serviceId: number) => void;
  onShowAvailableServices?: () => void;
};

const Summary = ({
  pickedEmployee,
  pickedServices,
  pickedProducts,
  showAddAdditionalService = true,
  showPickedEmployee,
  showPickedServices,
  showPickedProducts,
  onRemoveService,
  onShowAvailableServices,
}: SummaryProps) => {
  return (
    <Fragment>
      <div className="border-black-100 pb-xs border-b">
        <Header label={_s(`${baseTranslationKey}.header`)} h="span" size="sm" />
      </div>
      <ul>
        {showPickedEmployee && pickedEmployee && <EmployeeItem employee={pickedEmployee} />}
        {showPickedServices &&
          (pickedServices || []).map((service) => {
            /**
             * if only one non-addon service is picked, do not allow removal of the non-addon service
             */
            const mainServices = pickedServices.filter((service) => !service?.about?.settings?.isAddOn);
            const isAddon = service?.about?.settings?.isAddOn;
            const canRemove = onRemoveService && (mainServices.length > 1 || isAddon);
            return (
              <PickedService
                key={service.id}
                service={service}
                {...(canRemove && { onRemove: () => onRemoveService(service.id) })}
              />
            );
          })}
        {showPickedProducts &&
          (pickedProducts || []).map((product, idx) => {
            return <PickedProduct key={`product-${idx}`} product={product} />;
          })}
        {showAddAdditionalService && (
          <ListItem
            leftPadding={false}
            rightPadding={false}
            onClick={() => onShowAvailableServices?.()}
            leftSlot={<Icon variant="plus-circle" color="black-900" />}>
            <ListItemContent
              content={_s(`${baseTranslationKey}.link.add`)}
              contentClassName="text-information-700 underline"
            />
          </ListItem>
        )}
      </ul>
    </Fragment>
  );
};

export default Summary;
